import apiClient from './client';

// Ad Setup
export async function getAdSetup(domainId: number) {
    const response = await apiClient.get(`/ad-setup/${domainId}`);
    return response.data;
}

export async function createAdSetup(data: any) {
    const response = await apiClient.post('/ad-setup', data);
    return response.data;
}

export async function updateAdSetup(domainId: number, data: any) {
    const response = await apiClient.put(`/ad-setup/${domainId}`, data);
    return response.data;
}

export async function generateScript(domainId: number) {
    const response = await apiClient.post(`/ad-setup/${domainId}/generate-script`);
    return response.data;
}
